export const claimTypes = {
  Players: "BOOLEAN.PlayerService.CanEditAllPlayers",
  Games: "ENUM.GameService.CanEditGames",
  Events: "ENUM.EventService.CanEditEvents",
  Locations: "BOOLEAN.LocationService.CanEditLocations",
  Systems: "BOOLEAN.SystemService.CanEditSystems"
}